<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisStaticMap from 'dashboard/components-next/LaisStaticMap.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import VisitConfirmationSkeleton from './VisitConfirmationSkeleton.vue';

defineProps({
  visit: { type: Object, default: () => ({}) },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm', 'edit-entry']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <VisitConfirmationSkeleton v-if="loading" />
  <div
    v-else
    class="grid gap-4 rounded-lais border border-lais-border bg-white p-5"
  >
    <LaisStaticMap
      :src="visit.imovel?.coverUrl || visit.imovel?.thumbnailUrl"
      :alt="visit.imovel?.titulo || 'Imóvel da visita'"
      aspect-class="h-[200px]"
    />
    <div>
      <h2 class="font-redHatDisplay text-[22px] font-semibold text-lais-text">
        {{ visit.imovel?.titulo || 'Imóvel da visita' }}
      </h2>
      <p class="mt-1 text-[13px] text-lais-text-muted">
        {{ visit.scheduledAt || visit.scheduled_at || 'Data a confirmar' }}
      </p>
    </div>
    <button
      type="button"
      class="rounded-lais border border-lais-border px-4 py-3 text-left text-[13px] text-lais-text"
      @click="emit('edit-entry')"
    >
      <strong>Entrada no imóvel:</strong>
      {{ visit.entryAuthorization || 'Revisar forma de entrada' }}
    </button>
    <div
      v-if="visit.tenantLiving"
      class="rounded-lais border border-amber-200 bg-amber-50 px-4 py-3 text-[13px] text-amber-900"
    >
      Há morador no imóvel. Confirme a entrada antes de seguir.
    </div>
    <LaisPrimaryButton icon="i-lucide-calendar-check" @click="emit('confirm')">
      Confirmar visita
    </LaisPrimaryButton>
  </div>
</template>
